//https://github.com/shurique/p2p-cht/blob/master/src/middleware/socket.js
import * as actions from '../actions/socket';
import {paramsFetchData, paramWsFetch} from "../actions/params";
import {BASE_URL, KP, WS_STR} from '../../../settings';

const ENDPOINT = WS_STR;
const TIMEOUT = 5000;
const API_FETCH_URL = `${BASE_URL}/cur/${KP}/`;

function wsCreate(endpoint, store) {
    const ws = new WebSocket(endpoint);

    ws.onopen = () => {
        store.dispatch(actions.connectionCreated());
    };

    ws.onclose = () => {
        store.dispatch(actions.connectionClosed());
    };

    ws.onerror = () => {
        store.dispatch(actions.connectionError());
    };

    ws.onmessage = (event) => {
        const wsMessage = JSON.parse(event.data);
        store.dispatch(paramWsFetch(wsMessage));
    };

    return ws;
}

// function wsSend(ws, type, data = {}) {
//     return ws.send(JSON.stringify({ type, data }));
// }

function socketMiddleware() {
    // eslint-disable-next-line
    let socket = null;
    let reconnectTimer = null;

    return store => next => (action) => {
        switch (action.type) {
            case 'WS_CONNECT': {
                socket = wsCreate(ENDPOINT, store);

                clearTimeout(reconnectTimer);
                reconnectTimer = null;
                break;
            }
            case 'WS_CLOSED':
            case 'WS_ERROR': {
                store.dispatch(paramsFetchData(API_FETCH_URL));
                reconnectTimer = setTimeout(() => {
                    store.dispatch(actions.wsConnect());
                }, TIMEOUT);

                break;
            }
            default:
                return next(action);
        }
    };
}

export default socketMiddleware();


// WEBPACK FOOTER //
// ./src/lib/redux/middleware/socket.js